import { TaskGroupSummary } from 'modules/Tasks/types';
import collectiveApi from 'modules/common/collectiveApi';

export default async function getMemberTaskGroups(location?: string): Promise<TaskGroupSummary[]> {
    const { data } = await collectiveApi.get<TaskGroupSummary[]>('/v2/members/tasks/groups/', {
        params: {
            ...(location !== undefined && { location }),
        },
    });
    return data;
}
